import { render, staticRenderFns } from "./proof-filepicker.vue?vue&type=template&id=72ca3fe6&scoped=true&"
import script from "./proof-filepicker.vue?vue&type=script&lang=js&"
export * from "./proof-filepicker.vue?vue&type=script&lang=js&"
import style0 from "./proof-filepicker.vue?vue&type=style&index=0&id=72ca3fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca3fe6",
  null
  
)

export default component.exports